import React from 'react'

interface Props {
  text: string
  color: string
  withCheckBox?: boolean
  backgroundColor?: string
  borderColor?: string
}

const Badge = ({
  text,
  color,
  withCheckBox = true,
  backgroundColor = '#FAFAFA',
  borderColor = '#E4E4E7'
}: Props): JSX.Element => {
  return (
    <div className="flex">
      <div
        style={{ backgroundColor, borderColor }}
        className="flex flex-row justify-center items-center px-[10px] py-[2px] pl-[6px] border rounded-[6px]">
        {withCheckBox && (
          <div className="relative w-[20px] h-[20px]">
            <div
              style={{ backgroundColor: color }}
              className="absolute w-[10px] h-[10px] left-[calc(50%-5px)] top-[calc(50%-5px)] border-[0.5px] border-[rgba(24,24,27,0.24)] rounded-[2px]"
            />
          </div>
        )}
        <div style={{ color }} className="md:font-normal md:text-sm leading-5 text-center text-xs font-medium">
          {text}
        </div>
      </div>
    </div>
  )
}

export default Badge
